import { Component } from '@angular/core';
import { AccordionModule } from 'primeng/accordion';

interface Question {
  question: string
  answer: string
}

@Component({
  selector: 'app-home-faq',
  standalone: true,
  imports: [AccordionModule],
  templateUrl: './home-faq.component.html',
  styleUrl: './home-faq.component.scss'
})
export class HomeFaqComponent {
  faq: Question[] = [
    {
      question: "What is a \"Render Credit\".",
      answer: "A render credit is used to generate renders on the platform, with 1 credit = 1 render. Your balance is only charged once a render is successfully saved, so you never lose credits unfairly. Plus, bulk purchases come with exclusive discounts! If you frequently run out of credits, consider upgrading to an unlimited subscription for uninterrupted rendering."
    },
    {
      question: "What browsers and devices are supported?",
      answer: "Our web app works best on Chrome and Edge on desktop. If you're running into issues, please try one of these browser on desktop devices. Mobile support is limited due to the complexity of editing tools (cough safari)."
    },
    {
      question: "Is there a free version?",
      answer: "Yes! <a href='https://devforum.roblox.com/t/minimap-render-rorenderv3/965827'>RoRenderV3</a> has been free and open-source for years. However, it has a more limited feature set than this version. For example, it lacks a map editor, mesh texture rendering, and runs entirely on your personal machine rather than the cloud."
    },
    {
      question: "What happens if I run out of render credits?",
      answer: "You can purchase additional credits at any time. Bulk purchases come with discounts, and if you need frequent rendering, our unlimited subscription might be a better value."
    },
    {
      question: "Why does my render look different from the preview?",
      answer: "The preview is a scaled-down version optimized for quick editing, while the final render is generated at full resolution with all effects applied accurately. Some differences may occur due to scaling and processing differences."
    },
    {
      question: "How long does a render take?",
      answer: "Rendering time depends on the complexity of the scene, resolution, and the number of mesh textures. While simple renders usually finish in seconds, larger or more detailed maps may take longer. We’re constantly optimizing RoRender to deliver the fastest performance possible, ensuring it runs smoothly within Roblox’s capabilities."
    },
    {
      question: "I have a specific question I don't see answered anywhere.",
      answer: "Join our <a href='https://discord.gg/hgTaVCWc'>Discord</a> to connect with the community, ask questions, suggest features, and get help with all things RoRender. For the fastest support, Discord is the way to go! If you prefer email, you can reach us at <a href='mailto:support@rorender.com'>support@rorender.com</a>, and we'll get back to you as soon as possible."
    },
  ]
}
